import ChequeStatusUpdater from "./ChequeStatusUpdater";

export default ChequeStatusUpdater;
